var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "Subheader",
        { attrs: { dense: "", title: "Schema Fields", "no-search": "" } },
        [
          _c(
            "v-btn",
            {
              attrs: { color: "green", small: "" },
              on: { click: _vm.addSchemaField },
            },
            [
              _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
              _vm._v("\n      " + _vm._s(_vm.$t("Button.Add")) + "\n    "),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-alert",
        { attrs: { color: "info", icon: "info", value: !_vm.hasFields } },
        [
          _vm._v(
            "There are no metadata fields associated with this schema.\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _vm.systemDefiendFields && _vm.systemDefiendFields.length > 0
            ? _c("v-flex", { attrs: { xs12: "" } }, [
                _vm._v("\n      System Defined Fields\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.systemDefiendFields, function (field, index) {
            return [
              _c(
                "v-layout",
                {
                  key: field.Id,
                  staticClass: "tile-layout",
                  attrs: { row: "", wrap: "", "fill-height": "" },
                },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md3: "", "pa-1": "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          box: "",
                          label: "Field Name",
                          "hide-details": "",
                          readonly: "",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.modifySchemaField(field)
                          },
                        },
                        model: {
                          value: field.Field,
                          callback: function ($$v) {
                            _vm.$set(field, "Field", $$v)
                          },
                          expression: "field.Field",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md3: "", "pa-1": "" } },
                    [
                      _c("v-select", {
                        attrs: {
                          box: "",
                          label: "Field Type",
                          "hide-details": "",
                          items: _vm.fieldTypeNames,
                          readonly: "",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.modifySchemaField(field)
                          },
                        },
                        model: {
                          value: field.FieldType,
                          callback: function ($$v) {
                            _vm.$set(field, "FieldType", $$v)
                          },
                          expression: "field.FieldType",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-flex", { staticClass: "pt-1", attrs: { shrink: "" } }),
                ],
                1
              ),
              _vm._v(" "),
              index + 1 < _vm.systemDefiendFields.length
                ? _c("v-divider", { key: _vm.dividerKey(field.Id) })
                : _vm._e(),
            ]
          }),
          _vm._v(" "),
          _vm.userDefinedFields && _vm.userDefinedFields.length > 0
            ? _c("v-flex", { attrs: { xs12: "" } }, [
                _vm._v("\n      User Defined Fields\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.userDefinedFields, function (field, index) {
            return [
              _c(
                "v-layout",
                {
                  key: field.Id,
                  staticClass: "tile-layout",
                  attrs: { row: "", wrap: "", "fill-height": "" },
                },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md3: "", "pa-1": "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          box: "",
                          label: "Field Name",
                          "hide-details": "",
                          disabled: field.SystemDefined,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.modifySchemaField(field)
                          },
                        },
                        model: {
                          value: field.Field,
                          callback: function ($$v) {
                            _vm.$set(field, "Field", $$v)
                          },
                          expression: "field.Field",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md3: "", "pa-1": "" } },
                    [
                      _c("v-select", {
                        attrs: {
                          box: "",
                          label: "Field Type",
                          "hide-details": "",
                          items: _vm.fieldTypeNames,
                          disabled: field.SystemDefined,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.modifySchemaField(field)
                          },
                        },
                        model: {
                          value: field.FieldType,
                          callback: function ($$v) {
                            _vm.$set(field, "FieldType", $$v)
                          },
                          expression: "field.FieldType",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { staticClass: "pt-1", attrs: { shrink: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            fab: "",
                            small: "",
                            outline: "",
                            color: "error",
                            disabled: field.SystemDefined,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.removeSchemaField(field.Id)
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              index + 1 < _vm.userDefinedFields.length
                ? _c("v-divider", { key: _vm.dividerKey(field.Id) })
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-card-actions",
        [
          _c(
            "v-btn",
            { attrs: { color: "success" }, on: { click: _vm.onSubmitForm } },
            [
              _c("v-icon", [_vm._v("done")]),
              _vm._v("\n      " + _vm._s(_vm.finishedButtonText) + "\n    "),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }